import React from "react";
import {useHistory} from "react-router-dom";
import {StyledBackButton} from "./BackButton.styles";
import {ArrowLeftOutlined} from "@ant-design/icons";

export const BackButton = () => {
    const history = useHistory();
    return (
        <StyledBackButton
            type="primary"
            icon={<ArrowLeftOutlined />}
            size="middle"
            onClick={() => history.push("/musteri")}
        />
    );
};
